import React from "react";
import { FormControl, Text, Textarea } from "@chakra-ui/react";
import { InputProps } from "../../types/component";

export default function TextAreaInput({
  label,
  current_value,
  update_action,
  size,
}: InputProps) {
  const width =
    size === "small" ? "100px" : size === "medium" ? "250px" : "400px";
  return (
    <FormControl>
      {label && (
        <Text textStyle="s2" mb="4px">
          {label}
        </Text>
      )}
      <Textarea
        value={current_value}
        onChange={(e) => update_action(e.target.value)}
        width={width}
        height="75px"
        paddingX="12px"
        paddingY="8px"
        border="1px"
        borderColor="#C5C8D8"
        borderRadius="8px"
        fontFamily="Nunito"
        fontWeight="400"
        fontSize="12px"
        color="text.dark"
        _focus={{
          borderColor: "#C5C8D8",
          boxShadow: "none",
        }}
      />
    </FormControl>
  );
}
